import { legacyColors } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = () => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateAreas: '"header header" "column1 column2"',
    gridGap: theme.spacing(0, 2),
  },
  header: {
    gridArea: 'header',
  },
  column1: {
    gridArea: 'column1',
  },
  column2: {
    gridArea: 'column2',
  },
  divider: {
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(-0.375),
    marginBottom: theme.spacing(-0.375),
  },
  arrowDesc: {
    marginRight: '4px',
    paddingBottom: '5px',
  },
  arrowAsc: {
    marginRight: '4px',
    paddingTop: '10px',
  },
  pendingBlue: {
    color: legacyColors.primary,
  },
  pendingLabels: {
    marginBottom: '14px',
    display: 'flex',
    gap: '5px',
  },
});
